import ServicePageTemplate from '../../components/sections/ServicePageTemplate';
import { SERVICE_PAGES } from '../../config/servicePagesData';

export default function LegacySoftwareModernizationPage() {
  return <ServicePageTemplate service={SERVICE_PAGES.legacySoftwareModernization} />;
}
